module.exports = __webpack_public_path__ + "static/media/tiresias_infofont.f2354560.ttf";